import { createContext, useContext } from 'react';

// Provided by DashboardLayout: whether the current user may open a dashboard path,
// using the same rules as the side menu (role, page access, selected services).
export const PageAccessContext = createContext({ canOpen: () => true });

export function useCanOpen() {
  return useContext(PageAccessContext).canOpen;
}
